var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.availability && _vm.currentVariation.stock.net > 0
    ? _c("span", { staticClass: "product-detail-availability" }, [
        _c(
          "a",
          {
            attrs: {
              "data-toggle": "modal",
              href: "#deliverytime",
              title: "delivery-time",
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "product-detail-availability__svg",
                attrs: { xmlns: "http://www.w3.org/2000/svg" },
              },
              [
                _c("use", {
                  attrs: {
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "xlink:href": "#svg-delivery",
                  },
                }),
              ]
            ),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$translate(
                    "OD3dprimaV2::Template.availabilityDeliveryTime"
                  )
                ) +
                " "
            ),
            _c("strong", [_vm._v(_vm._s(_vm.name))]),
          ]
        ),
      ])
    : _c(
        "span",
        [
          _vm.showEstimatedDate
            ? [
                _vm.hasShippingCostsCategoryId
                  ? _c(
                      "a",
                      {
                        attrs: {
                          "data-toggle": "modal",
                          href: "#deliverytime",
                          title: _vm.$translate(
                            "Ceres::Template.singleItemShippingCosts"
                          ),
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "product-detail-availability__truck",
                            attrs: {
                              id: "Ebene_1",
                              "data-name": "Ebene 1",
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 400 400",
                            },
                          },
                          [
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z",
                              },
                            }),
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.estimatedAvailable) +
                            "\n        "
                        ),
                      ]
                    )
                  : _c(
                      "a",
                      {
                        attrs: {
                          "data-toggle": "modal",
                          href: "#deliverytime",
                          title: _vm.$translate(
                            "Ceres::Template.singleItemShippingCosts"
                          ),
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "product-detail-availability__truck",
                            attrs: {
                              id: "Ebene_1",
                              "data-name": "Ebene 1",
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 400 400",
                            },
                          },
                          [
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z",
                              },
                            }),
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n           " +
                            _vm._s(_vm.estimatedAvailable) +
                            "\n        "
                        ),
                      ]
                    ),
              ]
            : _vm.orderOnRequest
            ? _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$translate("OD3dprimaV2::Template.orderOnRequest")
                    ) +
                    "\n    "
                ),
              ])
            : [
                _vm.hasShippingCostsCategoryId
                  ? _c(
                      "a",
                      {
                        attrs: {
                          "data-toggle": "modal",
                          href: "#deliverytime",
                          title: _vm.$translate(
                            "Ceres::Template.singleItemShippingCosts"
                          ),
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "product-detail-availability__truck",
                            attrs: {
                              id: "Ebene_1",
                              "data-name": "Ebene 1",
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 400 400",
                            },
                          },
                          [
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z",
                              },
                            }),
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.estimatedAvailable) +
                            "\n        "
                        ),
                      ]
                    )
                  : _c(
                      "a",
                      {
                        attrs: {
                          "data-toggle": "modal",
                          href: "#deliverytime",
                          title: _vm.$translate(
                            "Ceres::Template.singleItemShippingCosts"
                          ),
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "product-detail-availability__truck",
                            attrs: {
                              id: "Ebene_1",
                              "data-name": "Ebene 1",
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 400 400",
                            },
                          },
                          [
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z",
                              },
                            }),
                            _c("path", {
                              staticClass: "cls-1",
                              attrs: {
                                d: "M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n           " +
                            _vm._s(_vm.estimatedAvailable) +
                            "\n        "
                        ),
                      ]
                    ),
              ],
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }